module.exports = {
  id: 21,
  name: 'Zebra Gallops',
  categories: ['cardio', 'legs', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Coordination',
  points: 13,
  instructions:
    'Zebra Gallops make you run like a zebra! Stand with your feet apart, gallop to the right, then gallop to the left, like a zebra running! This makes you fast and coordinated!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to gallop like a wild zebra? Let us build incredible speed and coordination!',
    },
    {
      time: 3,
      text: 'Stand with feet shoulder-width apart, bend your knees slightly!',
    },
    {
      time: 6,
      text: 'Use your arms to help you move, get ready to gallop!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Gallop like a wild zebra!',
    },
    // SET 1 - 12 gallops (6 right + 6 left)
    {
      time: 12,
      text: 'Perfect! Stand with feet shoulder-width apart, use your arms!',
    },
    {
      time: 15,
      text: 'Number 1! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 18,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 21,
      text: 'Number 2! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 24,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 27,
      text: 'Number 3! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 30,
      text: 'Use your arms to help you move!',
    },
    {
      time: 33,
      text: 'Number 4! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 36,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 39,
      text: 'Number 5! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 42,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 45,
      text: 'Number 6! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 48,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 51,
      text: 'Number 7! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 54,
      text: 'Use your arms to help you move!',
    },
    {
      time: 57,
      text: 'Number 8! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 60,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 63,
      text: 'Number 9! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 66,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 69,
      text: 'Number 10! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 72,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 75,
      text: 'Number 11! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 78,
      text: 'Use your arms to help you move!',
    },
    {
      time: 81,
      text: 'Number 12! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 84,
      text: 'Great job! Take a deep breath and shake out your legs!',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 87,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 90,
      text: 'Shake out your legs and get ready for round two!',
    },
    {
      time: 93,
      text: 'You are building incredible speed and coordination! Ready for round two?',
    },
    {
      time: 96,
      text: 'Remember to use your arms and bend your knees!',
    },
    {
      time: 99,
      text: '3, 2, 1, START! Gallop like a wild zebra!',
    },
    // SET 2 - 12 gallops (6 right + 6 left)
    {
      time: 102,
      text: 'Perfect! Stand with feet shoulder-width apart, use your arms!',
    },
    {
      time: 105,
      text: 'Number 1! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 108,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 111,
      text: 'Number 2! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 114,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 117,
      text: 'Number 3! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 120,
      text: 'Use your arms to help you move!',
    },
    {
      time: 123,
      text: 'Number 4! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 126,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 129,
      text: 'Number 5! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 132,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 135,
      text: 'Number 6! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 138,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 141,
      text: 'Number 7! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 144,
      text: 'Use your arms to help you move!',
    },
    {
      time: 147,
      text: 'Number 8! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 150,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 153,
      text: 'Number 9! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 156,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 159,
      text: 'Number 10! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 162,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 165,
      text: 'Number 11! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 168,
      text: 'Use your arms to help you move!',
    },
    {
      time: 171,
      text: 'Number 12! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 174,
      text: 'Great job! Take a deep breath and shake out your legs!',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 177,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 180,
      text: 'Shake out your legs and get ready for round three!',
    },
    {
      time: 183,
      text: 'You are building incredible speed and coordination! Ready for round three?',
    },
    {
      time: 186,
      text: 'Remember to use your arms and bend your knees!',
    },
    {
      time: 189,
      text: '3, 2, 1, START! Gallop like a wild zebra!',
    },
    // SET 3 - 12 gallops (6 right + 6 left)
    {
      time: 192,
      text: 'Perfect! Stand with feet shoulder-width apart, use your arms!',
    },
    {
      time: 195,
      text: 'Number 1! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 198,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 201,
      text: 'Number 2! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 204,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 207,
      text: 'Number 3! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 210,
      text: 'Use your arms to help you move!',
    },
    {
      time: 213,
      text: 'Number 4! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 216,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 219,
      text: 'Number 5! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 222,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 225,
      text: 'Number 6! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 228,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 231,
      text: 'Number 7! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 234,
      text: 'Use your arms to help you move!',
    },
    {
      time: 237,
      text: 'Number 8! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 240,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 243,
      text: 'Number 9! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 246,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 249,
      text: 'Number 10! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 252,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 255,
      text: 'Number 11! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 258,
      text: 'Use your arms to help you move!',
    },
    {
      time: 261,
      text: 'Number 12! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 264,
      text: 'Great job! Take a deep breath and shake out your legs!',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 267,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 270,
      text: 'Shake out your legs and get ready for the final round!',
    },
    {
      time: 273,
      text: 'You are building incredible speed and coordination! Ready for the final round?',
    },
    {
      time: 276,
      text: 'Remember to use your arms and bend your knees!',
    },
    {
      time: 279,
      text: '3, 2, 1, START! Gallop like a wild zebra!',
    },
    // SET 4 - 12 gallops (6 right + 6 left)
    {
      time: 282,
      text: 'Perfect! Stand with feet shoulder-width apart, use your arms!',
    },
    {
      time: 285,
      text: 'Number 1! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 288,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 291,
      text: 'Number 2! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 294,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 297,
      text: 'Number 3! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 300,
      text: 'Use your arms to help you move!',
    },
    {
      time: 303,
      text: 'Number 4! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 306,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 309,
      text: 'Number 5! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 312,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 315,
      text: 'Number 6! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 318,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 321,
      text: 'Number 7! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 324,
      text: 'Use your arms to help you move!',
    },
    {
      time: 327,
      text: 'Number 8! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 330,
      text: 'You are building incredible speed and coordination!',
    },
    {
      time: 333,
      text: 'Number 9! Gallop to the right, use your arms to help you move!',
    },
    {
      time: 336,
      text: 'Keep your balance and coordination!',
    },
    {
      time: 339,
      text: 'Number 10! Gallop to the left, bend your knees and use your arms!',
    },
    {
      time: 342,
      text: 'Feel your heart beating faster!',
    },
    {
      time: 345,
      text: 'Number 11! Gallop to the right, keep your feet shoulder-width apart!',
    },
    {
      time: 348,
      text: 'Use your arms to help you move!',
    },
    {
      time: 351,
      text: 'Number 12! Gallop to the left, bend your knees and stay balanced!',
    },
    {
      time: 354,
      text: 'Great job! Take a deep breath and shake out your legs!',
    },
    // COMPLETION
    {
      time: 357,
      text: 'Incredible work! You just did 48 zebra gallops!',
    },
    {
      time: 360,
      text: 'You are building incredible speed, coordination, and cardio fitness!',
    },
    {
      time: 363,
      text: 'Great job, zebra master! You are getting super fast and coordinated!',
    },
  ],
};
